export default __webpack_public_path__ + "static/media/subscription-icon.a8c626ad.svg";